module.exports = "<div id=\"map\"></div>\n<input id=\"searchBox\" type=\"text\" placeholder=\"\">\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/map/map.component.html
// module id = ../../../../../src/app/map/map.component.html
// module chunks = main